import { colors, fonts, glyphs, useMediaQuery } from '../../Styles';
import { useTranslation } from 'react-i18next';
import { AnimalGroupInfo } from '../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalGroupCall';

interface groupCard_Props {
  selectedGroup: AnimalGroupInfo
  onClick?: () => void
}

export default function GroupCard({selectedGroup, onClick}:groupCard_Props) {
  const { t } = useTranslation();

  return ( <>
    <div onClick={onClick} style={{
      borderRadius: "10px",
      height: "fit-content",
      overflow: "hidden",
      border: "5px solid "+colors.greyPrimary, 
      minWidth: "310px",
      width: "100%",
      minHeight: "50px",
      boxSizing: "border-box",
      gridTemplateColumns: "50px 1fr",
      gridTemplateRows: "1fr",
      display: "grid",
      cursor: onClick !== undefined ? "pointer" : "default"
    }}>

      <div style={{gridArea: "1/1/2/2", backgroundColor: colors.greyPrimary, display: "flex", justifyContent: "center", alignItems: "center"}}>
        <div style={{marginLeft: "-5px"}}><glyphs.AnimalGroup size="35px"/></div>
      </div>

      <div style={{
        gridArea: "1/2/2/3", 
        backgroundColor: colors.greyLightTertiary, 
        borderRadius: "0px 5px 5px 0px", 
        display: "grid",       
        gridTemplateColumns: "1fr 2px 150px",
        gridTemplateRows: "1fr",
        padding: "10px",
        gap: "10px",
        boxSizing: "border-box",
        pointerEvents: "none"
        }}>
        <div style={{gridArea: "1/1/2/2", ...fonts.header, ...fonts.fontSize4, color: colors.greyDarkPrimary, display: "flex", justifyContent: "start", alignItems: "center", wordBreak: "break-word"}}>{t("animalPages.animalGroups.group", {defaultValue: "Group"})} {selectedGroup.name}</div>
        <div style={{gridArea: "1/2/2/3", backgroundColor: colors.greyTertiary}}/>
        <div style={{ gridArea: "1/3/2/4", ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary, display: "flex", justifyContent: "start", alignItems: "center" }}>{t("animalPages.animalGroups.numberOfAnimals", { defaultValue: "Number of Animals" })}: {selectedGroup.animalsCount}</div>
      </div>

    </div>
  </> )
}